export const onChangeModalImgSrc = 'details/change-modal-img';
export const onCloseModal = 'details/close-modal';
export const onOpenModal = 'details/open-modal';
